<template>
  <div>
    <el-select
      :value="value"
      :class="className"
      size="small"
      filterable
      clearable
      @change="handleChange"
      :loading="loading"
      placeholder="请选择"
      style="width: 100%"
      :popper-append-to-body="false"
    >
      <el-option
        v-for="item in lists"
        :key="item"
        :label="item"
        :value="item"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
import { formParamList } from '../../service/getData'

export default {
  props: {
    value: '',
    category: 0,
    className: '',
  },
  data() {
    return {
      lists: [],
      loading: false,
    }
  },
  created() {
    this.requestData(this.category)
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e)
    },

    async requestData(query) {
      let data = {
        category: this.category,
        size: 200,
      }
      let res = await formParamList(data)
      this.loading = false
      this.lists = res.data.list.map((item) => {
        return item.name
      })
    },
  },
}
</script>
<style>
.select-err .el-input__inner {
  border-color: #f56c6c;
}
</style>